import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Form,
  Label,
  FormGroup,
  Input,
  Button,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';

function Home(args) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [online, setOnline] = useState(navigator.onLine);
  const [choixClient, setChoixClient] = useState('on');
  const [offreFourniture, setOffreFourniture] = useState('on');
  const [selectValue, setSelectValue] = useState('');
console.log(selectValue);
  // Function to send data to the server
  const sendDataToServer = async (event) => {
    event.preventDefault();

    const form = event.target;
    const formData = new FormData(form);

    try {
      // Check if online
      if (navigator.onLine) {
        const response = await fetch('https://applications.alphitan-system.tech/send.php', {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          console.log('Form data sent successfully');
          form.reset();
        } else {
          console.log('Error sending form data:', response.statusText);
        }
      } else {
        // If offline, store data in local storage
        const data = {};
        formData.forEach((value, key) => {
          data[key] = value;
        });

        storeDataLocally(data);
        console.log('Form data stored locally');
        form.reset();
      }
    } catch (error) {
      console.error('Error sending form data:', error);
    }
  };

  // Function to store data locally
  const storeDataLocally = (data) => {
    const allFieldsFilled = Object.values(data).every((val) => val !== '');

    if (allFieldsFilled) {
      let storedData = localStorage.getItem('formData');

      if (storedData) {
        storedData = JSON.parse(storedData);
        storedData.push(data);
        localStorage.setItem('formData', JSON.stringify(storedData));
      } else {
        localStorage.setItem('formData', JSON.stringify([data]));
      }
    }
  };

  // Event listeners for online and offline events
  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
      // When online, try sending locally stored data
      sendLocallyStoredData();
    };

    const handleOffline = () => setOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Function to send locally stored data when online
  const sendLocallyStoredData = () => {
    const storedData = localStorage.getItem('formData');

    if (storedData) {
      const parsedData = JSON.parse(storedData);

      parsedData.forEach(async (data) => {
        try {
          const formData = new FormData();

          // Append key-value pairs from the data object to the FormData object
          Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value);
          });

          const response = await fetch('https://applications.alphitan-system.tech/send.php', {
            method: 'POST',
            body: formData,
          });

          if (response.ok) {
            console.log('Locally stored form data sent successfully');
            // Remove the sent data from local storage
            removeLocallyStoredData();
          } else {
            console.log('Error sending locally stored form data:', response.statusText);
          }
        } catch (error) {
          console.error('Error sending locally stored form data:', error);
        }
      });
    }
  };

  // Function to remove locally stored data
  const removeLocallyStoredData = () => {
    localStorage.removeItem('formData');
  };

  // Event listeners for online and offline events
  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);


  return (
    <div>
      <Navbar expand={true} {...args}>
        <NavbarBrand href="/">
          <img alt='logo-alphitan'
               src="https://www.alphitan.com/wp-content/uploads/2019/07/GROUP-Couleur2.png" style={{
            height: '55%',
            width: '70%',
          }}/>
        </NavbarBrand>
        <NavbarToggler onClick={toggle}/>
        <Collapse className='d-flex justify-content-end' isOpen={isOpen} navbar>
          <Nav navbar>
            <NavItem>
              <NavLink href="/">Accueil</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#/suivisCommercial">Suivis commercial</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
      <div className='container-fluid'>
        <div>
          {online ? (
            <p className='text-success' style={{
              fontSize: '35px',
            }}>Vous êtes en ligne</p>
          ) : (
            <p className='text-danger' style={{
              fontSize: '35px',
            }}>Vous êtes hors ligne</p>
          )}
        </div>
      </div>
      <div className='container-fluid'>
        <Form onSubmit={sendDataToServer}>
          <FormGroup>
            <Label for="mailcommercial">
              Adresse Email Commercial :
            </Label>
            <Input
              id="mailcommercial"
              name="mailcommercial"
              placeholder="Entrer l'adresse votre e-mail commercial"
              type="email"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="image">Photo de la demande</Label>
            <Input className="form-control-file" type="file" id="image" name="image" accept="image/*"/>
          </FormGroup>
          <FormGroup>
            <Label for="client">
              Client :
            </Label>
            <Input
              id="client"
              name="client"
              placeholder="Entrer le nom du client"
              type="text"
            />
          </FormGroup>
          <FormGroup>
            <Label for="mailclient">
              Adresse Email Client :
            </Label>
            <Input
              id="mailclient"
              name="mailclient"
              placeholder="Entrer l'adresse e-mail du client"
              type="email"
            />
          </FormGroup>
          <FormGroup>
            <Label for="telephoneclient">
              Numéro de téléphone Client :
            </Label>
            <Input
              id="telephoneclient"
              name="telephoneclient"
              placeholder="Entrer le numéro de téléphone du client"
              type="tel"
            />
          </FormGroup>
          <FormGroup>
            <Label for="codepostal">
              Code Postal :
            </Label>
            <Input
              id="codepostal"
              name="codepostal"
              placeholder="Entrer le code postal client"
              type="number"
            />
          </FormGroup>
          <FormGroup>
            <Label for="zone">Sélectionnez une Zone :</Label>
            <Input
              type="select"
              name="zone"
              id="zone"
              value={selectValue}
              onChange={(e) => setSelectValue(e.target.value)}
            >
              <option value="">Choisissez...</option>
              <option value="1">Zone 1</option>
              <option value="2">Zone 2</option>
              <option value="3">Zone 3</option>
              <option value="4">Zone 4</option>
              <option value="5">Zone 5</option>
              <option value="6">Zone 6</option>
              <option value="7">Zone 7</option>
              <option value="8">Zone 8</option>
              <option value="9">Zone 9</option>
              <option value="10">Zone 10</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="reference">
              Référence :
            </Label>
            <Input
              id="reference"
              name="reference"
              placeholder="Entrer la référence"
              type="text"
            />
          </FormGroup>
          <FormGroup>
            <Label for="marque">
              Marque :
            </Label>
            <Input
              id="marque"
              name="marque"
              placeholder="Entrer la marque"
              type="text"
            />
          </FormGroup>
          <FormGroup>
            <Label for="priorite">
              Priorité :
            </Label>
            <Input
              id="priorite"
              name="priorite"
              type="select"
            >
              <option>
                1 Standard
              </option>
              <option>
                2 Urgent
              </option>
              <option>
                3 Prioritaire
              </option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="description">
              Description :
            </Label>
            <Input
              id="exampleText"
              name="text"
              type="textarea"
              placeholder="Une description de la panne"
            />
          </FormGroup>
          <FormGroup tag="fieldset">
            <legend>
              Choix Client
            </legend>
            <FormGroup check>
              <Input
                name="radio1"
                type="radio"
                value="on"
                checked={choixClient === 'on'}
                onChange={() => setChoixClient('on')}
              />
              {' '}
              <Label check>
                Le client souhaite être informer de l'avancement
              </Label>
            </FormGroup>
            <FormGroup check>
              <Input
                name="radio1"
                type="radio"
                value="off"
                checked={choixClient === 'off'}
                onChange={() => setChoixClient('off')}
              />
              {' '}
              <Label check>
                Le client ne souhaite pas être informé de l'avancement
              </Label>
            </FormGroup>
          </FormGroup>
          <FormGroup>
            <Input
              name="offreFourniture"
              type="radio"
              id="offreFourniture"
              value="on"
              checked={offreFourniture === 'on'}
              onChange={() => setOffreFourniture('on')}
            />
            {' '}
            <Label for="offreFourniture" check>
              Le client souhaite une offre de fourniture en parallèle
            </Label>
          </FormGroup>
          <FormGroup>
            <Input
              name="offreFourniture"
              type="radio"
              value="off"
              id="offreFourniture"
              checked={offreFourniture === 'off'}
              onChange={() => setOffreFourniture('off')}
            />
            {' '}
            <Label for="offreFourniture" check>
              Le client ne souhaite pas avoir une offre de fourniture en parallèle
            </Label>
          </FormGroup>
          <FormGroup check>
            <Input type="checkbox" required={true}/>
            {' '}
            <Label check>
              Je valide les informations saisies pour l'envoi.
            </Label>
          </FormGroup>
          <Button type="submit" className='mt-3'>
            Envoyer les informations
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default Home;
